import getPrizeForPosition from '../../helpers/getPrizeForPosition';
import { TournamentFragment } from '@/shared/graphql/TournamentFragment.generated';

type Props = {
  tournament?: TournamentFragment;
};

const PositionPrize: FC<Props> = ({ tournament }) => {
  const prizeForPosition = getPrizeForPosition({
    prizes: tournament?.prizes,
    position: tournament?.myScore?.position,
  });

  return <p className="text-moon-14 text-bulma">{prizeForPosition?.name}</p>;
};

export default PositionPrize;
